import React from "react";
import { Create } from "react-admin";
import { StoreTabbedForm } from "./StoreTabbedForm";

export const StoreCreate = (props) => (
  <Create title="Criar Loja" {...props}>
    <StoreTabbedForm {...props} />
  </Create>
);
